import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropPrimaryDataByCropIdAndYear } from "services";

import { getActiveToken, getEnvironment, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

export const useGetFootprintingCropPrimaryData = (farmId?: string, cropId?: string, year?: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, cropId, year, isAdmin],
      queryFn: () => getFootprintingCropPrimaryDataByCropIdAndYear(farmId ?? "", year ?? 0, cropId ?? ""),
      enabled: !!farmId && !!cropId && !!year && !!user && !!token && !!carbonProgram?.platformFeatures?.footprinting?.enabled,
      gcTime: 60000,
    },
    queryClient
  );
};
